import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {config} from "../../../constant";

export default function DialogLinkCategories({open, onClose, onSave}) {
    const navigate = useNavigate();
    const [archiveCategories, setArchiveCategories] = useState(null);
    const [links, setLinks] = useState(null);
    const [year, setYear] = useState(null);

    useEffect(() => {
        fetch(`${config.BASE_URL}/archives/link-categories`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            }).then(data => {
                setArchiveCategories(data.archiveCategories);
                setLinks(data.archiveCategoryLinks);
            }).catch(error => {
                const message = 'Erreur dans la récupération des liens de catégories';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    }, []);

    const save = () => {
        // console.log('links + ' + JSON.stringify(links));
        const configuration = {
            year: year,
            archiveCategoryLinks: links
        };
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(configuration)
        };
        fetch(`${config.BASE_URL}/archives/from-result`, requestOptions)
            .then(response => {
                onSave();
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            }).catch(error => {
                const message = 'Erreur dans la création de l\'archive';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const handleYearChange = (event) => {
        const {
            target: {name, value}
        } = event;

        setYear(value);
    };

    const handleArchiveCategoryChange = (event) => {
        const {
            target: {name, value}
        } = event;

        const nextLinks = [...links];
        const foundLink = nextLinks.find(link => link.category.id === parseInt(name, 10));
        if (value) {
            foundLink.archiveCategory = archiveCategories.find(archiveCategory => archiveCategory.id === parseInt(value, 10));
        } else {
            foundLink.archiveCategory = null;
        }

        setLinks(nextLinks);
    };

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Rapprochement des catégories</DialogTitle>
        <DialogContent>
            <TextField
                margin="dense"
                id="year"
                name="year"
                label="Année"
                fullWidth
                variant="standard"
                value={year}
                onChange={handleYearChange}
            />
            {links && links.map(link => (
                <FormControl sx={{mt: 2}} key={link.category.id} fullWidth>
                    <InputLabel id={'label-' + link.category.id}>{link.category.name}</InputLabel>
                    <Select
                        labelId={'label-' + link.category.id}
                        id={link.category.id}
                        name={link.category.id.toString()}
                        value={link.archiveCategory ? link.archiveCategory.id : null}
                        label={link.category.name}
                        fullWidth
                        onChange={handleArchiveCategoryChange}
                    >
                        {archiveCategories.map(category => (
                            <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            ))}
        </DialogContent>
        <DialogActions>
            <Button onClick={save}>OK</Button>
        </DialogActions>
      </Dialog>
    );
}
